import React from 'react'
import { TabBar } from 'react-native-tab-view';
import { useUnistyles } from 'react-native-unistyles';
import usePlatform from '@/utils/hooks/usePlatform';

export default function ReachTabBar(props) {
    const { theme: {colors} } = useUnistyles();
    const {isWeb, isNative} = usePlatform();

    return (
        <TabBar
            {...props}
            scrollEnabled={props.scrollEnabled ?? isNative}
            contentContainerStyle={{ alignItems: "center" }}
            indicatorStyle={{ backgroundColor: colors.primary, height: 1.5, borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
            tabStyle={{width: isWeb || isNative ? "auto" : undefined, paddingHorizontal: 16}}
            activeColor={colors.primary}
            inactiveColor={colors.textSecondary}
            style={{ backgroundColor: 'transparent', borderBottomColor: colors.border, borderBottomWidth: 0.5}}
        />
    )
}
